import {
  MERCADOPAGO_ERROR,
  MERCADOPAGO_LOADING,
  MERCADOPAGO_SUCCESS,
  MERCADOPAGO_RESET,
  MERCADOPAGO_REFERENCIA,
  MERCADOPAGO_REFERENCIA_LOADING,
  RESET_PORTAL_CONTEXT,
} from "../ActionTypes";

import mercadoPagoInitialState from "../initialStates/mercadoPagoInitialState";

const mercadoPago = (state, { payload, type }) => {
  switch (type) {
    case MERCADOPAGO_LOADING:
      return {
        ...state,
        mercadoPago: {
          ...state.mercadoPago,
          error: false,
          loading: true,
        },
      };

    case MERCADOPAGO_SUCCESS:
      return {
        ...state,
        mercadoPago: {
          ...state.mercadoPago,
          loading: false,
          error: false,
          data: payload,
        },
      };
    case MERCADOPAGO_ERROR:
      return {
        ...state,
        mercadoPago: {
          ...state.mercadoPago,
          error: payload,
          loading: false,
        },
      };
    case MERCADOPAGO_REFERENCIA:
      return {
        ...state,
        referencia: {
          ...state.referencia,
          loading: false,
          error: false,
          data: payload,
        },
      };
    case MERCADOPAGO_REFERENCIA_LOADING:
      return {
        ...state,
        referencia: {
          ...state.referencia,
          error: false,
          loading: true,
        },
      };
    case MERCADOPAGO_RESET:
      return mercadoPagoInitialState;
    case RESET_PORTAL_CONTEXT:
      return mercadoPagoInitialState;

    default:
      return state;
  }
};

export default mercadoPago;
